/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationAttachmentDownload200,
  GetApiV1DocumentCourseRegistrationAttachmentDownload401,
  GetApiV1DocumentCourseRegistrationAttachmentDownload403,
  GetApiV1DocumentCourseRegistrationAttachmentDownload404,
  GetApiV1DocumentCourseRegistrationAttachmentDownload500,
  GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams,
  GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationAttachmentDownload.ts";

export const getApiV1DocumentCourseRegistrationAttachmentDownloadQueryParamsSchema =
  z
    .object({
      attachmentId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationAttachmentDownload200Schema =
  z.string() as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownload200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationAttachmentDownload401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownload401>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationAttachmentDownload403Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownload403>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationAttachmentDownload404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownload404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationAttachmentDownload500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownload500>;

export const getApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponseSchema =
  z.lazy(
    () => getApiV1DocumentCourseRegistrationAttachmentDownload200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationAttachmentDownloadQueryResponse>;
